import React from 'react'

function ToolTip({ title, description }) {
    return (
        <div><h1><strong>{title}</strong></h1> <br></br> <h4>{description}</h4></div>
    )
}

export default ToolTip